export const timelineData = [
  { year: '2019', label: '人工评价基础', desc: '天津以全员听评课为基础，构建统一评价指标和市级评课队伍' },
  { year: '2019-2024', label: '数据积累', desc: '累计录制3.66万个课堂实景视频，形成评课数据近21万份' },
  { year: '2024', label: '教育部中心', desc: '2024年教育部在天津设立高校思政课教学质量评价监测中心。' },
  { year: '2025', label: '云智评', desc: '系统投喂7000节实录课程，标记1.2万条课例数据，人机吻合度93.8%' },
  { year: '2026', label: '全国推广', desc: '从天津样板走向全国方案，服务高校思政课教学质量提升' },
];

export const threeQuestions = [
  {
    id: 1,
    question: 'AI评得准吗？',
    sub: '可信度验证',
    icon: 'ri-shield-check-line',
    color: 'accent',
    answer: '有标准、有训练、有验证',
  },
  {
    id: 2,
    question: 'AI怎么评？',
    sub: '技术原理',
    icon: 'ri-brain-line',
    color: 'primary',
    answer: '多模态识别→指标映射→专用模型评价',
  },
  {
    id: 3,
    question: 'AI怎么用？',
    sub: '应用场景',
    icon: 'ri-user-settings-line',
    color: 'accent',
    answer: '服务教师、学生、专家和管理者',
  },
];

export const threeAnswers = [
  {
    id: 1,
    title: '有标准',
    subtitle: '评价指标结构化',
    desc: 'AI不是凭感觉写点评，而是把思政课评价指标结构化，将学情调研、理论阐释、案例实践、互动设计、价值引领等17项细分指标纳入评价框架。',
    icon: 'ri-list-check',
    points: ['学情调研', '理论阐释', '案例实践', '互动设计', '价值引领'],
  },
  {
    id: 2,
    title: '有训练',
    subtitle: '专家样本进入专用模型',
    desc: '评价指标不是停留在表格上，而是进入训练后的思政课专用评价模型，成为模型识别课堂片段、判断教学维度的依据。',
    icon: 'ri-robot-2-line',
    points: ['7000节实录课程', '1.2万条课例标记', '优秀教师标记', '专用评价模型'],
  },
  {
    id: 3,
    title: '有验证',
    subtitle: '总分/维度分/分档结果可比对',
    desc: '系统输出的综合总分、维度分、分档结果和证据链，通过历史样本、人机比对和专家抽检持续校准。',
    icon: 'ri-shield-star-line',
    points: ['历史样本校准', '人机比对验证', '专家抽检复核', '持续迭代优化'],
  },
];

export const evaluationFlow = [
  { id: 1, title: '课堂材料', desc: '视频、音频、课件、板书', icon: 'ri-folder-video-line', color: 'accent' },
  { id: 2, title: '多模态识别', desc: '文字、声音、画面识别', icon: 'ri-scan-line', color: 'primary' },
  { id: 3, title: '指标映射', desc: '关键片段映射评价维度', icon: 'ri-map-pin-2-line', color: 'accent' },
  { id: 4, title: '专用模型评价', desc: '训练后思政课专用模型', icon: 'ri-brain-line', color: 'primary' },
  { id: 5, title: '证据链', desc: '结果+证据同时出现', icon: 'ri-links-line', color: 'accent' },
  { id: 6, title: '评价结果', desc: '总分/维度分/分档/建议', icon: 'ri-bar-chart-grouped-line', color: 'primary' },
];

export const dualPerspective = [
  {
    role: '管理者',
    icon: 'ri-building-2-line',
    color: 'primary',
    items: [
      { label: '质量趋势', desc: '一所学校、一个地区、一批课程的整体质量态势' },
      { label: '资源配置', desc: '哪些课程发展稳定，哪些主题需要加强，资源该投向哪里' },
      { label: '区域跟踪', desc: '分档比例、质量地图和趋势预警' },
    ],
    outputs: ['趋势图', '分档比例', '质量地图'],
  },
  {
    role: '优秀教师',
    icon: 'ri-graduation-cap-line',
    color: 'accent',
    items: [
      { label: '有效方法', desc: '哪些教学设计有效，哪些课堂方法值得推广' },
      { label: '经验迁移', desc: '个人经验如何变成可复制的教研资源' },
      { label: '成长提升', desc: '证据卡、案例建议和成长跟踪' },
    ],
    outputs: ['证据卡', '案例建议', '成长跟踪'],
  },
];

export const roadmapSteps = [
  {
    id: 1,
    title: '成果基础',
    desc: '六年数据积累与系统验证',
    icon: 'ri-database-2-line',
    color: 'primary',
  },
  {
    id: 2,
    title: '评价难点',
    desc: '思政课为什么难评价',
    icon: 'ri-error-warning-line',
    color: 'accent',
  },
  {
    id: 3,
    title: 'AI评课原理',
    desc: 'AI怎么工作',
    icon: 'ri-brain-line',
    color: 'primary',
  },
  {
    id: 4,
    title: '案例演示',
    desc: '三个真实评课案例',
    icon: 'ri-file-list-3-line',
    color: 'accent',
  },
  {
    id: 5,
    title: '应用服务与质量跟踪',
    desc: '四类对象服务 · 一师一档 · 一校一图 · 一省一图',
    icon: 'ri-government-line',
    color: 'accent',
  },
  {
    id: 6,
    title: '总结',
    desc: '从单课评价到区域跟踪',
    icon: 'ri-chat-quote-line',
    color: 'primary',
  },
];

export const reportPreview = {
  totalScore: 87,
  grade: '良好',
  gradeColor: 'accent',
  dimensions: [
    { name: '政治方向', score: 92, full: 100 },
    { name: '理论阐释', score: 85, full: 100 },
    { name: '案例使用', score: 88, full: 100 },
    { name: '互动设计', score: 78, full: 100 },
    { name: '价值引导', score: 91, full: 100 },
  ],
  evidence: [
    { type: '视频片段', desc: '"我们要坚持社会主义核心价值观"——15:40', tag: '价值引导' },
    { type: '互动记录', desc: '学生主动提问，教师引导讨论——22:10', tag: '互动设计' },
    { type: '课件页码', desc: '结合时事案例阐述理论——08:23', tag: '案例使用' },
  ],
  suggestion: '互动设计维度分数偏低，建议在课堂中增加开放性提问和学生讨论环节，可参考系统中"优秀互动设计"案例库。',
};

export const navLinks = [
  { label: '天津样板到全国方案', target: 'section-1' },
  { label: '经验评课到智能评价', target: 'section-2' },
  { label: 'AI如何评一堂思政课', target: 'section-3' },
  { label: '应用服务与质量跟踪', target: 'section-5' },
  { label: '总结', target: 'section-6' },
];